export default __webpack_public_path__ + "static/media/pdf-tutorial.0e2b8ab6.png";